import React, { createContext, useState, useContext, useEffect } from 'react';
import { getCart as fetchCart } from '../utils/api';
import { useAuth } from './AuthContext';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const { user } = useAuth();

  const refreshCart = async () => {
    if (user) {
      try {
        const res = await fetchCart();
        setCartItems(res.data);
        const count = res.data.reduce((sum, item) => sum + item.cart_item.quantity, 0);
        setCartCount(count);
      } catch (error) {
        console.error('Failed to fetch cart:', error);
      }
    } else {
      setCartItems([]);
      setCartCount(0);
    }
  };

  useEffect(() => {
    refreshCart();
  }, [user]);

  return (
    <CartContext.Provider value={{ cartItems, cartCount, refreshCart }}>
      {children}
    </CartContext.Provider>
  );
};